import { useDispatch, useSelector } from "react-redux";
import Modal from "../../UI/Modal";
import Loader from "../../UI/Loader";
import { closeConfirmToggle } from "../../../store/reducers/frasesConfirmacion/Frasesconfirmacionplantel.reducer";
import { toggleFraseConfirmacionPlantelActiveThunk } from "../../../store/reducers/frasesConfirmacion/Frasesconfirmacionplantel.thunks";

const ConfirmToggleModalFrasePlantel = () => {
  const dispatch = useDispatch();
  const { confirmModalOpen, toggleFraseId, toggling } = useSelector(
    (state) => state.frasesConfirmacionPlantel,
  );

  const frase = useSelector((state) =>
    state.frasesConfirmacionPlantel.list.find((f) => f.id === toggleFraseId),
  );

  const handleConfirm = () => {
    dispatch(toggleFraseConfirmacionPlantelActiveThunk(toggleFraseId));
  };

  return (
    <Modal
      open={confirmModalOpen}
      onClose={() => dispatch(closeConfirmToggle())}
      title="Confirmación"
      size="sm"
    >
      {toggling ? (
        <Loader center text="Actualizando frase..." type="dots" size="sm" />
      ) : (
        <>
          <p className="mb-3">
            ¿Seguro que quieres{" "}
            <strong>{frase?.is_active ? "desactivar" : "activar"}</strong> la
            frase <strong>"{frase?.frase}"</strong>?
          </p>

          <div className="d-flex justify-content-end gap-2">
            <button
              className="btn btn-secondary"
              onClick={() => dispatch(closeConfirmToggle())}
            >
              Cancelar
            </button>
            <button className="btn btn-primary" onClick={handleConfirm}>
              Confirmar
            </button>
          </div>
        </>
      )}
    </Modal>
  );
};

export default ConfirmToggleModalFrasePlantel;
